<template>
  <v-card class="rounded-card card-shadow fill-height">
    <v-card-title class="font-weight-bold pl-5">
      Listagem de perguntas
    </v-card-title>
    <v-card-text class="text--primary">
      <div>
        <px-pendencias-lista-perguntas
          :perguntas="perguntas" :loading="loading"
          :on-change-options="onChangeOptions"
          :options-list="optionsList"
          @update="onClickRefresh"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import PerguntasService from './perguntas-service';
import PendenciasListaPerguntas from './PendenciasListaPerguntas.vue';

export default {
  props: {
    dataMes: Object,
  },
  mixins: [paginationMixin],
  data() {
    return {
      perguntas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'horarioPergunta',
        sortDesc: false,
      },
      loading: false,
      optionsList: {},
      query: 'resposta is null',
    };
  },
  methods: {
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getPerguntas();
    },
    onClickRefresh() {
      this.getPerguntas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getPerguntas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      this.listOptions.filter = this.query;

      return PerguntasService.getPerguntas({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.perguntas = response.data;
          this.$emit('loaded', this.perguntas);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    pxPendenciasListaPerguntas: PendenciasListaPerguntas,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
